import { Version } from './types'

let changelog: Version[]

try {
  // This will be resolved by webpack alias at build time
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  changelog = require('changelog-env').default
} catch (e) {
  // No webpack alias
  changelog = []
}

export default changelog
